(() => {
  function initGuide(root) {
    if (root.dataset.guideReady) return;
    const ui = root.querySelector('[data-guide-interface]');
    const steps = [...root.querySelectorAll('[data-guide-step]')];
    const groups = [...root.querySelectorAll('[data-moment-options]')];
    const results = [...root.querySelectorAll('[data-guide-result]')];
    const back = root.querySelector('[data-guide-back]');
    const status = root.querySelector('[data-guide-status]');
    if (!ui || !back || !status || steps.length !== 3) return;
    root.dataset.guideReady = 'true';
    let step = 0;
    let selectedMoment = null;
    const labels = ['one', 'two', 'result'].map(key => root.querySelector(`[data-guide-step-${key}]`).content.textContent.trim());
    function showStep(next, focus = true) {
      step = next;
      steps.forEach((panel, index) => { panel.hidden = index !== next; });
      back.hidden = next === 0;
      status.textContent = labels[next];
      if (focus) {
        const heading = next === 2 ? results.find(panel => !panel.hidden)?.querySelector('h3') : steps[next].querySelector('h3');
        heading?.focus({ preventScroll: false });
      }
    }
    root.addEventListener('click', event => {
      const momentButton = event.target.closest('[data-moment]');
      if (momentButton && root.contains(momentButton)) {
        selectedMoment = momentButton.dataset.moment;
        groups.forEach(group => { group.hidden = group.dataset.momentOptions !== selectedMoment; });
        results.forEach(panel => { panel.hidden = true; });
        showStep(1);
        return;
      }
      const choice = event.target.closest('[data-choice]');
      if (choice && root.contains(choice)) {
        const group = choice.closest('[data-moment-options]');
        if (!group || group.hidden || group.dataset.momentOptions !== selectedMoment) return;
        const target = results.find(panel => panel.dataset.guideResult === choice.dataset.choice);
        if (!target) return;
        results.forEach(panel => { panel.hidden = panel !== target; });
        showStep(2);
        return;
      }
      if (event.target.closest('[data-guide-back]')) showStep(step === 2 ? 1 : 0);
    });
    ui.hidden = false;
    showStep(0, false);
  }
  const scan = scope => scope.querySelectorAll('[data-be-guide]').forEach(initGuide);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();


(() => {
  const selector = '.cart-header-blocks .jdgm-all-reviews-text';
  function refresh() {
    document.querySelectorAll(selector).forEach(source => {
      const data = source.querySelector('[data-number-of-reviews]');
      if (!data) return;
      const score = Number(data.dataset.score);
      const count = Number(data.dataset.numberOfReviews);
      if (!Number.isFinite(score) || !Number.isFinite(count) || score < 0 || score > 5 || count <= 0) return;
      let summary = source.previousElementSibling;
      if (!summary?.classList.contains('be-cart-review-summary')) {
        summary = document.createElement('div');
        summary.className = 'be-cart-review-summary';
        const stars = document.createElement('span');
        stars.className = 'be-cart-review-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.append(document.createTextNode('★★★★★'));
        const fill = document.createElement('span');
        fill.textContent = '★★★★★';
        stars.append(fill);
        const rating = document.createElement('strong');
        const total = document.createElement('span');
        total.className = 'be-cart-review-count';
        summary.append(stars, rating, total);
        source.before(summary);
      }
      source.classList.add('be-cart-review-source');
      source.setAttribute('aria-hidden', 'true');
      const signature = score + ':' + count;
      if (summary.dataset.signature === signature) return;
      summary.dataset.signature = signature;
      summary.querySelector('.be-cart-review-stars > span').style.width = (score * 20) + '%';
      summary.querySelector('strong').textContent = score.toLocaleString('fr-FR', { maximumFractionDigits: 2 }) + '/5';
      summary.querySelector('.be-cart-review-count').textContent = count.toLocaleString('fr-FR') + ' avis';
      summary.setAttribute('role', 'img');
      summary.setAttribute('aria-label', 'Note de ' + score.toLocaleString('fr-FR') + ' sur 5, pour ' + count.toLocaleString('fr-FR') + ' avis');
    });
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; refresh(); });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-score', 'data-number-of-reviews'] });
  refresh();
})();
